import { request } from "utils/legacy_api";
import { objectToQueryString } from "utils";
import { apiNormalizeFilters } from "utils/metadata";

export function index(page = 1, filters: any = {}) {
  const params = apiNormalizeFilters(filters);
  return request(`/lessons?${objectToQueryString({ ...params, page })}`, {
    method: "GET"
  });
}
